// extracted by mini-css-extract-plugin
module.exports = {"panel":"SafeTraceBase_panel__3WJy5","main":"SafeTraceBase_main__1TdxJ"};